import {
  getTableDataWithVisibleColumns,
  getVisibleColumnIds,
} from "src/components/molecules/TableExportForm/utils";
import { Table } from "src/requests/table/types";
import { OverviewTablesByTemplateId } from "./types";

export const removeHiddenColumnsFromTable = (table: Table): Table => {
  const visibleColIds = getVisibleColumnIds(table.columns);
  return getTableDataWithVisibleColumns(table, visibleColIds);
};

export const transformToOverviewTablesByTemplateId = (
  overviewTablesByTemplateIds: Record<number, Table>
): OverviewTablesByTemplateId => {
  const templateIdTableEntries = Object.entries(
    overviewTablesByTemplateIds
  ).map(([templateId, table]) => {
    const tableWithoutHiddenCols = removeHiddenColumnsFromTable(table);
    return [templateId, tableWithoutHiddenCols];
  });

  return Object.fromEntries(templateIdTableEntries);
};

export const haveMissingTables = (
  overviewTables: OverviewTablesByTemplateId
): boolean => Object.values(overviewTables).some((table) => !table);

export const getMissingTableTemplateIds = (
  overviewTables: OverviewTablesByTemplateId
): number[] => {
  const missingEntries = Object.entries(overviewTables).filter(
    ([_, table]) => !table
  );
  return missingEntries.map(([templateId]) => templateId).map(Number);
};
